module.exports = new function downloadFile()
{
    const downloadableFile = $('[data-js-download]');

    downloadableFile.on('click', function(e) {
        e.preventDefault();

        const fileSrc = JSON.parse($(this).attr('data-js-download-src'));
        const url = fileSrc.url;
        const filename = fileSrc.filename;

        let xhr = new XMLHttpRequest();

        xhr.open("GET", url, true);
        xhr.responseType = "arraybuffer";
        xhr.onload = function(e) {
            console.log(this);
          if (this.status == 200) {
            const blob = this.response;
            const a = document.createElement("a");
            document.body.appendChild(a);
            const blobUrl = window.URL.createObjectURL(blob);
            a.href = blobUrl;
            a.download = filename;
            a.click();
            setTimeout(() => {
              window.URL.revokeObjectURL(blobUrl);
              document.body.removeChild(a);
            }, 0);
          }
        };

        xhr.send();
    });
};
